/**
 * «Вийти» ends the session on purpose: the sign-in screen then shows no
 * «Сесія завершилась». Reset once a session is seen again.
 */
let signingOut = false;

export function markSigningOut(): void {
  signingOut = true;
}

export function clearSigningOut(): void {
  signingOut = false;
}

export function isSigningOut(): boolean {
  return signingOut;
}
